// Özlük dosyası belge türleri (backend _OZLUK_KINDS ile aynı anahtarlar)
export const OZLUK_KINDS = [
  ["nufus_cuzdani", "Nüfus Cüzdanı Fotokopisi"],
  ["nufus_kayit", "Nüfus Kayıt Örneği"],
  ["ikametgah", "İkametgâh Belgesi"],
  ["is_sozlesmesi", "İmzalı İş Sözleşmesi"],
  ["adli_sicil", "Adli Sicil Kaydı"],
  ["diploma", "Diploma Fotokopisi"],
  ["saglik_raporu", "İşe Giriş Sağlık Raporu"],
  ["vesikalik", "Vesikalık Fotoğraf"],
  ["askerlik", "Askerlik Durum Belgesi"],
  ["isg_egitim", "İSG Eğitim Belgeleri"],
  ["performans", "Performans Değerlendirme Raporları"],
  ["disiplin", "Uyarılar ve Disiplin Tutanakları"],
  ["engelli_raporu", "Engelli Sağlık Kurulu Raporu ve GİB Engellilik İndirimi Yazısı"],
  ["calisma_izni", "Yabancı Çalışma İzni Kartı ve Pasaport Fotokopisi"],
];
export const OZLUK_KEYS = OZLUK_KINDS.map(([k]) => k);
// birden çok belge biriken türler (sürüm değil, ayrı belgeler): hepsi listelenir
export const OZLUK_MULTI = ["isg_egitim", "performans", "disiplin"];
